import { render } from "./BookingItem.vue?vue&type=template&id=cd602fa2&scoped=true"
import script from "./BookingItem.vue?vue&type=script&lang=js"
export * from "./BookingItem.vue?vue&type=script&lang=js"

import "./BookingItem.vue?vue&type=style&index=0&id=cd602fa2&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd602fa2"]])

export default __exports__